
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Stotra "Jaya Ganapati Sadhguna Sadana" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Stotra "Jaya Ganapati Sadhguna Sadana" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shri Ganesh Chalisa, Ganapati Chalisa, Jaya Ganapati, Ganapati Chalisa lyrics, Ganapati Chalisa lyrics english, ganesh chalisa mantra'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Jaya Ganapati, Shri Ganesh Chalisa, Ganapati Chalisa prayer, Sadhguna Sadana, Ganesh Chalisa chant, Ganapati Chalisa lyrics, Ganapati Chalisa lyrics in marathi, Ganapati Chalisa lyrics in english, Ganapati Chalisa mantra, Shri Ganesh Chalisa, श्री गणेश चालीसा' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/ganesh-chalisa.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/ganesh-chalisa.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Jaya Ganapati Sadhguna Sadana | Shri Ganesh Chalisa - जय गणपति सदगुण सदन(श्री गणेश चालीसा)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/ganesh-chalisa"
        },
        "headline": "Jaya Ganapati Sadhguna Sadana - जय गणपति सदगुण सदन(श्री गणेश चालीसा)",
        "name" : "Jaya Ganapati Sadhguna Sadana - Shri Ganesh Chalisa",
        "description": "Explore the full lyrics of stotra 'Jaya Ganapati Sadhguna Sadana' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/ganesh-chalisa.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  